module.exports = __webpack_public_path__ + "img/Icon_Switch.355e4210.svg";